


























import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import Modal from '../Modal.vue';

@Component<VideoModal>({
  components: {
    Modal
  }
})
export default class VideoModal extends Vue {
  @Prop() visible!: boolean;
  @Prop() title!: string;
  @Prop() url!: string;

  @Ref() readonly video!: HTMLVideoElement;

  @Emit()
  close() {}

  @Watch('visible')
  handleVisibleChange(value: boolean) {
    if (!value) this.video?.pause();
  }
}
